import type { GridColumnGroupingModel } from '@repo/go-table';
import { useMemo } from 'react';

import { TableHeader } from '../components/TableHeader/TableHeader';

import { FIELD_TO_AUTO_ANOMALIES_COLUMN_TITLE_KEY } from './FIELD_TO_AUTO_ANOMALIES_COLUMN_TITLE_KEY';

export const AUTO_ANOMALIES_COLUMN_GROUPS = [
  {
    groupId: 'anomalyTypeGroup',
    children: ['anomalyTypeId', 'anomalySubtypeId'],
  },
  {
    groupId: 'valueGroup',
    children: ['valueLimit', 'valueFact'],
  },
  {
    groupId: 'deltaGroup',
    children: ['valueAbsoluteDiff', 'valueRelativeDiff'],
  },
] as const;

export const AUTO_ANOMALIES_GROUPED_COLUMN_FIELDS = new Set<string>(
  AUTO_ANOMALIES_COLUMN_GROUPS.flatMap((group) => group.children),
);


export const useColumnGroups = () => {
  return useMemo(
    (): GridColumnGroupingModel => [
      {
        groupId: AUTO_ANOMALIES_COLUMN_GROUPS[0].groupId,
        children: AUTO_ANOMALIES_COLUMN_GROUPS[0].children.map((field) => ({ field })),
        renderHeaderGroup() {
          return (
            <TableHeader
              field={'anomalyTypeGroup'}
              textTKey={FIELD_TO_AUTO_ANOMALIES_COLUMN_TITLE_KEY['anomalyTypeGroup']}
            />
          );
        },
      },
      {
        groupId: AUTO_ANOMALIES_COLUMN_GROUPS[1].groupId,
        children: AUTO_ANOMALIES_COLUMN_GROUPS[1].children.map((field) => ({ field })),
        renderHeaderGroup() {
          return <TableHeader field={'valueGroup'} textTKey={FIELD_TO_AUTO_ANOMALIES_COLUMN_TITLE_KEY['valueGroup']} />;
        },
      },
      {
        groupId: AUTO_ANOMALIES_COLUMN_GROUPS[2].groupId,
        children: AUTO_ANOMALIES_COLUMN_GROUPS[2].children.map((field) => ({ field })),
        renderHeaderGroup() {
          return <TableHeader field={'deltaGroup'} textTKey={FIELD_TO_AUTO_ANOMALIES_COLUMN_TITLE_KEY['deltaGroup']} />;
        },
      },
    ],
    [],
  );
};
